var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("br"),
              _c(
                "b-button",
                {
                  staticClass: "ml-1",
                  attrs: {
                    size: "sm",
                    variant: "outline-primary",
                    title: "Update Data",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onOpenNew()
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "plus" } }),
                  _c("span", [_vm._v("New")]),
                ],
                1
              ),
              _c("br"),
              _c("b-table", {
                style: { "font-size": "11px" },
                attrs: {
                  id: "tbl-plan-data",
                  fields: _vm.fields,
                  items: _vm.items,
                  responsive: "",
                  "sticky-header": true,
                  hover: "",
                  "per-page": _vm.pagination.limit,
                  "current-page": _vm.pagination.current,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(plan_data)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getNamePlanData(row.item))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(creation_date)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.item.update_date || row.item.creation_date
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(creation_user)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.item.update_user || row.item.creation_user
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(action)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onView(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("visibility"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-modal", {
        ref: "my-modal-plan-data",
        attrs: {
          id: "my-modal-plan-data",
          size: "md",
          title: "Demo",
          "hide-footer": "",
          "no-close-on-backdrop": true,
          "no-close-on-esc": true,
        },
        scopedSlots: _vm._u([
          {
            key: "modal-title",
            fn: function () {
              return [
                _vm._v(
                  _vm._s(_vm.new_item.id ? "Edit" : "Create") +
                    " Strategic Plan"
                ),
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Name :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { size: "sm", disabled: _vm.readonly },
                                model: {
                                  value: _vm.new_item.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.new_item, "name", $$v)
                                  },
                                  expression: "new_item.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Definition :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { size: "sm", disabled: _vm.readonly },
                                model: {
                                  value: _vm.new_item.definition,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.new_item, "definition", $$v)
                                  },
                                  expression: "new_item.definition",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "OKRs :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c(
                                "b-list-group",
                                { key: _vm.key_okrs, attrs: { size: "sm" } },
                                [
                                  _vm._l(
                                    _vm.new_item.okrs,
                                    function (item, index) {
                                      return _c(
                                        "b-list-group-item",
                                        {
                                          key: index,
                                          staticClass: "p-2 form-control-sm",
                                          attrs: { size: "sm" },
                                        },
                                        [
                                          _c("span", [_vm._v(_vm._s(item))]),
                                          !_vm.readonly
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    right: "0",
                                                  },
                                                  attrs: { title: "Delete" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDelOkr(index)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                      staticStyle: {
                                                        color: "blue",
                                                        "font-size": "medium",
                                                      },
                                                    },
                                                    [_vm._v("delete")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  !_vm.readonly
                                    ? _c(
                                        "b-input-group",
                                        {
                                          staticClass: "mt-1",
                                          attrs: { size: "sm" },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              size: "sm",
                                              disabled: _vm.readonly,
                                            },
                                            model: {
                                              value: _vm.new_okr,
                                              callback: function ($$v) {
                                                _vm.new_okr = $$v
                                              },
                                              expression: "new_okr",
                                            },
                                          }),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true },
                                                },
                                              ],
                                              staticClass:
                                                "p-1 btn-outline-primary",
                                              attrs: {
                                                size: "sm",
                                                title: "Add OKR",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onAddOkr()
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                attrs: { icon: "plus" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "KPIs :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c(
                                "b-list-group",
                                { key: _vm.key_kpis, attrs: { size: "sm" } },
                                [
                                  _vm._l(
                                    _vm.new_item.kpis,
                                    function (item, index) {
                                      return _c(
                                        "b-list-group-item",
                                        {
                                          key: index,
                                          staticClass: "p-2 form-control-sm",
                                          attrs: { size: "sm" },
                                        },
                                        [
                                          _c("span", [_vm._v(_vm._s(item))]),
                                          !_vm.readonly
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    right: "0",
                                                  },
                                                  attrs: { title: "Delete" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDelKpi(index)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                      staticStyle: {
                                                        color: "blue",
                                                        "font-size": "medium",
                                                      },
                                                    },
                                                    [_vm._v("delete")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  !_vm.readonly
                                    ? _c(
                                        "b-input-group",
                                        {
                                          staticClass: "mt-1",
                                          attrs: { size: "sm" },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              size: "sm",
                                              disabled: _vm.readonly,
                                            },
                                            model: {
                                              value: _vm.new_kpi,
                                              callback: function ($$v) {
                                                _vm.new_kpi = $$v
                                              },
                                              expression: "new_kpi",
                                            },
                                          }),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true },
                                                },
                                              ],
                                              staticClass:
                                                "p-1 btn-outline-primary",
                                              attrs: {
                                                size: "sm",
                                                title: "Add KPI",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onAddKpi()
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                attrs: { icon: "plus" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Strategic Data Plan :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  disabled: _vm.readonly,
                                  options: _vm.plan_datas,
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.new_item.plan_data_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.new_item, "plan_data_id", $$v)
                                  },
                                  expression: "new_item.plan_data_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { sm: "12", lg: "12" } }, [
                      _c("div", { staticClass: "mt-3 row" }, [
                        _c(
                          "div",
                          { staticClass: "float-rigth col-12" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2",
                                attrs: { size: "sm" },
                                on: { click: _vm.onCancel },
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "material-icons md-16" },
                                  [_vm._v("cancel")]
                                ),
                                _c("span", [_vm._v("Cancel")]),
                              ]
                            ),
                            !_vm.readonly
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "active ml-2",
                                    attrs: { size: "sm", variant: "primary" },
                                    on: { click: _vm.onSavePlanPilar },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("send"),
                                    ]),
                                    _vm._v(
                                      _vm._s(_vm.$t("botones.boton_aceptar"))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }